import React from 'react';
import classNames from 'classnames';
import styles from './ProgressBar.module.scss';

export interface DownloadProgress {
  loaded: number;
  total: number;
}

interface ProgressBarProps {
  progress: DownloadProgress;
  showAnimation?: boolean;
  height?: number;
  className?: string;
  showPercentage?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  showAnimation = true,
  height = 32,
  className = '',
  showPercentage = false
}) => {
  
  const formatBytes = (bytes: number): string => {
    if (bytes === 0) return '0 Mo';
    const mb = bytes / (1024 * 1024);
    return `${mb.toFixed(1)} Mo`;
  };

  const getProgressPercentage = (): number => {
    if (progress.total === 0) return 0;
    return Math.min(100, (progress.loaded / progress.total) * 100);
  };

  const percentage = getProgressPercentage();
  const isLowProgress = percentage < 15;

  const displayText = showPercentage 
    ? `${Math.round(percentage)}%`
    : `${formatBytes(progress.loaded)} / ${formatBytes(progress.total)}`;

  return (
    <div className={classNames(styles.progressContainer, className)}>
      <div 
        className={classNames(styles.progressBar)}
        style={{ height: `${height}px`, borderRadius: `${height / 2}px` }}
      >
        <div 
          className={classNames(
            styles.progressFill,
            { [styles.animated]: showAnimation }
          )}
          style={{ 
            width: `${percentage}%`,
            borderRadius: `${height / 2}px`
          }}
        >
          {!isLowProgress && (
            <span className={classNames(styles.progressText)}>
              {displayText}
            </span>
          )}
        </div>
        
        {isLowProgress && (
          <span className={classNames(styles.progressTextOutside)}>
            {displayText}
          </span>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;